import { useLocalStorage } from '@mantine/hooks';
import { STORAGE_KEYS, URLS } from 'consts';
import { useNavigate } from 'react-router-dom';

export const useLogout = (navigateToHome: boolean = true) => {
  const navigate = useNavigate();
  const [, setToken] = useLocalStorage({
    key: STORAGE_KEYS.token,
  });

  return () => {
    setToken('null');
    navigateToHome && navigate(URLS.home);
  };
};
